import { Box } from '~/commonComponents';
import { Tab, TabList, Tabs } from '~/commonComponents/Tabs';
import { OnsiteInterviewStatus, OnsiteInterviewStatusMapper } from '~/domain/PermanentJobs';

interface IOnsiteInterviewStatusFilterPanelProps {
  counts: Record<OnsiteInterviewStatus, number>;
  onChange(tab: OnsiteInterviewStatus | 'all'): void;
}

export const OnsiteInterviewStatusFilterPanel = ({
  counts,
  onChange,
}: IOnsiteInterviewStatusFilterPanelProps) => {
  const tabs = [
    OnsiteInterviewStatus.ActionNeeded,
    OnsiteInterviewStatus.Open,
    OnsiteInterviewStatus.Scheduled,
    OnsiteInterviewStatus.Completed,
    OnsiteInterviewStatus.Cancelled,
  ];
  const totalCount = Object.values(counts).reduce((sum, count) => sum + count, 0);

  const handleTabChange = (idx: number) => {
    onChange(tabs[idx - 1] || 'all');
  };

  return (
    // @ts-expect-error JS Component
    <Tabs
      tabListStyle={{ gap: 16 }}
      style={{ alignItems: 'flex-start' }}
      onChangeTab={handleTabChange}
    >
      {/* @ts-expect-error JS Component */}
      <TabList>
        <Tab
          title={`All Active${totalCount > 0 ? ` (${totalCount})` : ''}`}
          textStyle={{
            fontSize: 20,
          }}
        />
        {tabs.map((it) => (
          <Tab
            PrefixComponent={
              <Box
                backgroundColor={OnsiteInterviewStatusMapper.getColor(it)}
                borderRadius="100%"
                height={10}
                width={10}
              />
            }
            key={it}
            title={`${OnsiteInterviewStatusMapper.toHumanReadable(it)}${counts[it] > 0 ? ` (${counts[it]})` : ''}`}
            textStyle={{
              fontSize: 20,
            }}
          />
        ))}
      </TabList>
    </Tabs>
  );
};
